import { AxiosResponse } from 'axios';
import { IOrganizationService } from './Interfaces/IOrganizationService';
import {
  Organization,
  OrganizationType,
  OrganizationLevel,
  OrganizationBankAccount,
  OrganizationInterface,
  OrganizationParameter,
  OrganizationCaseType,
  OrganizationCaseTypeStep,
  OrganizationCaseTypeStepForm,
  OrganizationForm,
  OrganizationFormAction,
  OrganizationFilterType,
  OrganizationToken,
  SetCredentials,
  OrganizationAttachment,
  OrganizationJobType,
  OrganizationOwnMake,
  OwnBrandCheckRequestDto,
  OwnBrandCheckResponseDto,
  SaveOrganizationOwnMakesRequestDto,
  SaveOrganizationOwnMakeResponseDto,
  OrganizationMaintenancePackage,
  OrganizationOilViscosity,
  CupiCodeCorespondence,
  OrganizationInvoiceRange,
  OrganizationOilMappingRequest,
  CountryBuffer,
  SellerData,
  CountrySupport,
  PowerBiReport,
  OilViscosityMakeCorrespondence,
  OrganizationAttachmentsFiltersDto,
  OrganizationAttachmentList,
  DealerStartStock,
  OrganizationInfoDto,
  OrganizationByIdsRequestDto,
  OrganizationBrandingDto,
  OrganizationDomainDto,
  SaveOrganizationDomainResponseDto,
  SaveOrganizationBrandingResponseDto,
  SaveOrganizationBuyoutConfigResponseDto,
  OrganizationBuyoutConfigDto,
  RegenerateOrganizationDomainApiKeyRequestDto,
  GetOrganizationsByTypesRequestDto,
  GetOrganizationsByTypeRequestDto,
  MaintenanceWorkflow,
  OrganizationSupplier,
  OrganizationSupplierProducerDiscount,
  OrganizationSupplierProducerDiscountResponseDto,
  OrganizationProvider,
  AddOrganizationProviderRequestDto,
  GetOrganizationProviderListRequestDto,
  ImportOrganizationsRequestDto,
  ImportOrganizationsResponseDto,
  GetOrganizationsRequestDto,
  IntegrationApiLogFilterRequestDto,
  IntegrationApiLogFilterResponseDto,
  GetUsersByIdsRequestDto,
  UserInformationDto,
  PartMappingDto,
  PartMappingImportRequestDto,
  PartMappingImportResponseDto,
  PartMappingFilterRequestDto,
  PartMappingFilterResponseDto,
  PartMappingDuplicateRequestDto,
  PartMappingDuplicateResponseDto,
  SavePartMappingResponseDto,
  DeletePartMappingResponseDto,
  PartMappingTreeResponseDto
} from '../interfaces/Organization';
import { API } from '../helpers/API';
import { TermeneResponseDto } from '../interfaces/Organization';
import { ICRUDService } from './Interfaces/ICRUDService';
import { CRUDService } from './CRUDService';
import { OrganizationLight } from '../interfaces/OrganizationLight';
import { IReferential } from '../interfaces/IReferential';

export class OrganizationService implements IOrganizationService {
  private baseController = '/organization';

  OrganizationToken: ICRUDService<OrganizationToken>;

  constructor() {
    this.OrganizationToken = new CRUDService(this.baseController, 'OrganizationToken');
  }
  public async AddOrganization(organization: Organization): Promise<Organization> {
    return (await API.PostAsync<Organization>(this.baseController, organization)).data;
  }

  public async UpdateOrganization(organization: Organization): Promise<void> {
    await API.PutAsync<Organization>(this.baseController, organization);
  }

  public async AddOrganizationType(organization: OrganizationType): Promise<OrganizationType> {
    return (
      await API.PostAsync<OrganizationType>(`${this.baseController}/organizationtype`, organization)
    ).data;
  }
  public async UpdateOrganizationType(organizationTyoe: OrganizationType): Promise<void> {
    await API.PutAsync<OrganizationType>(
      `${this.baseController}/organizationtype`,
      organizationTyoe
    );
  }

  public async GetByCompanyNumber(companyNumber: string): Promise<Organization> {
    return (
      await API.GetAsync<Organization>(`${this.baseController}/ByCompanyNumber/${companyNumber}`)
    ).data;
  }

  public async GetOrganizationsByIds(ids: number[]): Promise<Organization[]> {
    return (await API.Post2Async<number[], Organization[]>(`${this.baseController}/list`, ids))
      .data ?? [];
  }

  public async GetUserOrganizationsByIds(ids: number[]): Promise<Organization[]> {
    return (await API.Post2Async<number[], Organization[]>(`${this.baseController}/user`, ids))
      .data ?? [];
  }

  public async GetHOOrganizations(countryId: number | null): Promise<Organization[]> {
    return (
      await API.GetAsync<Organization[]>(
        `${this.baseController}/HOO/${countryId == null ? '' : countryId}`
      )
    ).data ?? [];
  }

  public async GetHOOrganizationsByTypes(types: string[]): Promise<Organization[]> {
    const typeList = types.join(',');

    return (await API.GetAsync<Organization[]>(`${this.baseController}/HO/${typeList}`)).data ?? [];
  }

  public async GetOrganizationsByType(request: GetOrganizationsByTypeRequestDto): Promise<Organization[]> {
    return (await API.Post2Async<GetOrganizationsByTypeRequestDto, Organization[]>(`${this.baseController}/by-type`, request)).data ?? [];
  }

  public async GetOrganizationsByHO(
    hoId: number,
    minLevelId: number | null
  ): Promise<Organization[]> {
    if (minLevelId !== null) {
      return (
        await API.GetAsync<Organization[]>(
          `${this.baseController}/byHO/${hoId}?minlevelId=${minLevelId}`
        )
      ).data ?? [];
    }

    return (await API.GetAsync<Organization[]>(`${this.baseController}/byHO/${hoId}`)).data ?? [];
  }

  public async GetGtOrganization(): Promise<Organization> {
    return (await API.GetAsync<Organization>(`${this.baseController}/GtOrganization`)).data;
  }

  public async GetCurrentOrganization(): Promise<Organization> {
    return (await API.GetAsync<Organization>(`${this.baseController}/Organization`)).data;
  }

  public async GetOrganization(id: number): Promise<Organization> {
    return (await API.GetAsync<Organization>(`${this.baseController}/Organization/${id}`)).data;
  }

  public async GetOrganizationInfo(id: number): Promise<Organization> {
    return (await API.GetAsync<Organization>(`${this.baseController}/Organization/${id}/info`))
      .data;
  }

  public async GetOrganizationsForTariffPartners(
    hoId: number,
    countryId: number | null
  ): Promise<Organization[]> {
    return (
      await API.GetAsync<Organization[]>(
        `${this.baseController}/tariffpartners/${hoId}/${countryId == null ? '' : countryId}`
      )
    ).data ?? [];
  }

  public async GetOrganizationHierarchy(hoId: number): Promise<Organization[]> {
    return (
      await API.GetAsync<Organization[]>(`${this.baseController}/GetOrganizationHierarchy/${hoId}`)
    ).data ?? [];
  }

  public async GetOrganizationDescendents(parentIds: number[]): Promise<OrganizationLight[]> {
    return (
      await API.Post2Async<number[], OrganizationLight[]>(
        `${this.baseController}/descendents`,
        parentIds
      )
    ).data ?? [];
  }

  public async GetOrganizationLevels(orgId: number): Promise<OrganizationLevel[]> {
    return (
      await API.GetAsync<OrganizationLevel[]>(`${this.baseController}/${orgId}/OrganizationLevels`)
    ).data ?? [];
  }

  public async AddOrganizationLevel(
    organizationLevel: OrganizationLevel
  ): Promise<OrganizationLevel> {
    return (
      await API.PostAsync<OrganizationLevel>(
        `${this.baseController}/organizationlevel`,
        organizationLevel
      )
    ).data;
  }

  public async UpdateOrganizationLevel(organizationLevel: OrganizationLevel): Promise<void> {
    await API.PutAsync<OrganizationLevel>(
      `${this.baseController}/organizationlevel`,
      organizationLevel
    );
  }

  public async RemoveOrganizationLevel(id: number): Promise<void> {
    return (await API.DeleteAsync<void>(`${this.baseController}/organizationlevel/${id}`)).data;
  }

  public async GetOrganizationFilters(orgId: number): Promise<OrganizationFilterType[]> {
    return (
      await API.GetAsync<OrganizationFilterType[]>(
        `${this.baseController}/${orgId}/OrganizationFilters`
      )
    ).data ?? [];
  }
  public async GetUserOrganizationFilters(orgId: number): Promise<OrganizationFilterType[]> {
    return (
      await API.GetAsync<OrganizationFilterType[]>(
        `${this.baseController}/OrganizationFilters/listUser/${orgId}`
      )
    ).data ?? [];
  }

  public async AddOrganizationFilter(
    organizationFilterType: OrganizationFilterType
  ): Promise<OrganizationFilterType> {
    return (
      await API.PostAsync<OrganizationFilterType>(
        `${this.baseController}/OrganizationFilterType`,
        organizationFilterType
      )
    ).data;
  }

  public async RemoveOrganizationFilter(id: number): Promise<void> {
    return (await API.DeleteAsync<void>(`${this.baseController}/OrganizationFilterType/${id}`))
      .data;
  }

  public async GetOrganizationBankAccounts(orgId: number): Promise<OrganizationBankAccount[]> {
    return (
      await API.GetAsync<OrganizationBankAccount[]>(
        `${this.baseController}/${orgId}/OrganizationBankAccounts`
      )
    ).data ?? [];
  }

  public async GetUserOrganizationBankAccounts(orgId: number): Promise<OrganizationBankAccount[]> {
    return (
      await API.GetAsync<OrganizationBankAccount[]>(
        `${this.baseController}/OrganizationBankAccount/listUser/${orgId}`
      )
    ).data ?? [];
  }

  public async AddOrganizationBankAccount(
    organizationBankAccount: OrganizationBankAccount
  ): Promise<OrganizationBankAccount> {
    return (
      await API.PostAsync<OrganizationBankAccount>(
        `${this.baseController}/OrganizationBankAccount`,
        organizationBankAccount
      )
    ).data;
  }

  public async UpdateOrganizationBankAccount(
    organizationBankAccount: OrganizationBankAccount
  ): Promise<void> {
    await API.PutAsync<OrganizationBankAccount>(
      `${this.baseController}/OrganizationBankAccount`,
      organizationBankAccount
    );
  }

  public async RemoveOrganizationBankAccount(id: number): Promise<void> {
    return (await API.DeleteAsync<void>(`${this.baseController}/OrganizationBankAccount/${id}`))
      .data;
  }

  public async GetOrganizationInterfaces(orgId: number): Promise<OrganizationInterface[]> {
    return (
      await API.GetAsync<OrganizationInterface[]>(
        `${this.baseController}/${orgId}/OrganizationInterfaces`
      )
    ).data ?? [];
  }

  public async GetInterfacesWithClientAccess(orgId: number): Promise<OrganizationInterface[]> {
    return (
      await API.GetAsync<OrganizationInterface[]>(
        `${this.baseController}/${orgId}/interfacesWithClientAccess`
      )
    ).data ?? [];
  }

  public async GetInterfaceAuthorizeUrl(orgId: number, interfaceId: number): Promise<string> {
    return (
      await API.GetAsync<string>(
        `${this.baseController}/${orgId}/interfacesWithClientAccess/${interfaceId}/authorizeUrl`
      )
    ).data;
  }

  public async AddOrganizationInterface(
    organizationInterface: OrganizationInterface
  ): Promise<OrganizationInterface> {
    return (
      await API.PostAsync<OrganizationInterface>(
        `${this.baseController}/OrganizationInterface`,
        organizationInterface
      )
    ).data;
  }

  public async UpdateOrganizationInterface(
    organizationInterface: OrganizationInterface
  ): Promise<void> {
    await API.PutAsync<OrganizationInterface>(
      `${this.baseController}/OrganizationInterface`,
      organizationInterface
    );
  }

  public async SetInterfaceCredentials(param: SetCredentials): Promise<void> {
    await API.PutAsync(
      `${this.baseController}/${param.orgId}/interfacesWithClientAccess/${param.interfaceId}/setCredentials`,
      param
    );
  }

  public async RemoveOrganizationInterface(id: number): Promise<void> {
    return (await API.DeleteAsync<void>(`${this.baseController}/OrganizationInterface/${id}`)).data;
  }

  public async GetOrganizationParameters(orgId: number): Promise<OrganizationParameter[]> {
    return (
      await API.GetAsync<OrganizationParameter[]>(
        `${this.baseController}/${orgId}/OrganizationParameters`
      )
    ).data ?? [];
  }

  public async AddOrganizationParameter(
    organizationParameter: OrganizationParameter
  ): Promise<OrganizationParameter> {
    return (
      await API.PostAsync<OrganizationParameter>(
        `${this.baseController}/OrganizationParameter`,
        organizationParameter
      )
    ).data;
  }

  public async UpdateOrganizationParameter(
    organizationParameter: OrganizationParameter
  ): Promise<void> {
    await API.PutAsync<OrganizationParameter>(
      `${this.baseController}/OrganizationParameter`,
      organizationParameter
    );
  }

  public async RemoveOrganizationParameter(id: number): Promise<void> {
    return (await API.DeleteAsync<void>(`${this.baseController}/OrganizationParameter/${id}`)).data;
  }

  public async GetOrganizationCaseType(orgId: number): Promise<OrganizationCaseType[]> {
    return (
      await API.GetAsync<OrganizationCaseType[]>(
        `${this.baseController}/OrganizationCaseType/list/${orgId}`
      )
    ).data ?? [];
  }

  public async GetUserOrganizationCaseType(): Promise<OrganizationCaseType[]> {
    return (
      await API.GetAsync<OrganizationCaseType[]>(
        `${this.baseController}/OrganizationCaseType/listUser/`
      )
    ).data ?? [];
  }

  public async AddOrganizationCaseType(
    organizationCaseType: OrganizationCaseType
  ): Promise<OrganizationCaseType> {
    return (
      await API.PostAsync<OrganizationCaseType>(
        `${this.baseController}/organizationcasetype`,
        organizationCaseType
      )
    ).data;
  }

  public async UpdateOrganizationCaseType(
    organizationCaseType: OrganizationCaseType
  ): Promise<void> {
    await API.PutAsync<OrganizationCaseType>(
      `${this.baseController}/OrganizationCaseType`,
      organizationCaseType
    );
  }

  public async RemoveOrganizationCaseType(id: number): Promise<void> {
    return (await API.DeleteAsync<void>(`${this.baseController}/OrganizationCaseType/${id}`)).data;
  }

  public async GetOrganizationCaseTypeStep(
    orgCaseTypeId: number
  ): Promise<OrganizationCaseTypeStep[]> {
    return (
      await API.GetAsync<OrganizationCaseTypeStep[]>(
        `${this.baseController}/OrganizationCaseTypeStep/list/${orgCaseTypeId}`
      )
    ).data ?? [];
  }
  public async GetUserOrganizationCaseTypeStep(
    orgCaseTypeId: number
  ): Promise<OrganizationCaseTypeStep[]> {
    return (
      await API.GetAsync<OrganizationCaseTypeStep[]>(
        `${this.baseController}/OrganizationCaseTypeStep/listUser/${orgCaseTypeId}`
      )
    ).data ?? [];
  }
  public async AddOrganizationCaseTypeStep(
    OrganizationCaseTypeStep: OrganizationCaseTypeStep
  ): Promise<OrganizationCaseTypeStep> {
    return (
      await API.PostAsync<OrganizationCaseTypeStep>(
        `${this.baseController}/OrganizationCaseTypeStep`,
        OrganizationCaseTypeStep
      )
    ).data;
  }

  public async UpdateOrganizationCaseTypeStep(
    OrganizationCaseTypeStep: OrganizationCaseTypeStep
  ): Promise<void> {
    await API.PutAsync<OrganizationCaseTypeStep>(
      `${this.baseController}/organizationcasetypestep`,
      OrganizationCaseTypeStep
    );
  }

  public async RemoveOrganizationCaseTypeStep(id: number): Promise<void> {
    return (await API.DeleteAsync<void>(`${this.baseController}/organizationcasetypestep/${id}`))
      .data;
  }

  public async GetOrganizationCaseTypeStepForms(
    orgCaseTypeStepId: number
  ): Promise<OrganizationCaseTypeStepForm[]> {
    return (
      await API.GetAsync<OrganizationCaseTypeStepForm[]>(
        `${this.baseController}/OrganizationCaseTypeStepForm/list/${orgCaseTypeStepId}`
      )
    ).data ?? [];
  }

  public async GetUserOrganizationCaseTypeStepForms(
    orgCaseTypeStepId: number
  ): Promise<OrganizationCaseTypeStepForm[]> {
    return (
      await API.GetAsync<OrganizationCaseTypeStepForm[]>(
        `${this.baseController}/OrganizationCaseTypeStepForm/listUser/${orgCaseTypeStepId}`
      )
    ).data ?? [];
  }

  public async GetOrganizationCaseTypeStepForm(id: number): Promise<OrganizationCaseTypeStepForm> {
    return (
      await API.GetAsync<OrganizationCaseTypeStepForm>(
        `${this.baseController}/OrganizationCaseTypeStepForm/${id}`
      )
    ).data;
  }

  public async AddOrganizationCaseTypeStepForm(
    organizationCaseTypeStepForm: OrganizationCaseTypeStepForm
  ): Promise<OrganizationCaseTypeStepForm> {
    return (
      await API.PostAsync<OrganizationCaseTypeStepForm>(
        `${this.baseController}/OrganizationCaseTypeStepForm`,
        organizationCaseTypeStepForm
      )
    ).data;
  }

  public async UpdateOrganizationCaseTypeStepForm(
    organizationCaseTypeStepForm: OrganizationCaseTypeStepForm
  ): Promise<void> {
    await API.PutAsync<OrganizationCaseTypeStepForm>(
      `${this.baseController}/OrganizationCaseTypeStepForm`,
      organizationCaseTypeStepForm
    );
  }

  public async RemoveOrganizationCaseTypeStepForm(id: number): Promise<void> {
    return (
      await API.DeleteAsync<void>(`${this.baseController}/OrganizationCaseTypeStepForm/${id}`)
    ).data;
  }

  public async GetOrganizationForms(): Promise<OrganizationForm[]> {
    return (
      await API.GetAsync<OrganizationForm[]>(`${this.baseController}/referential/organizationform`)
    ).data ?? [];
  }

  public async GetOrganizationForm(orgForm: number): Promise<OrganizationForm> {
    return (
      await API.GetAsync<OrganizationForm>(`${this.baseController}/referential/organizationform`)
    ).data;
  }

  public async UpdateOrganizationForm(organizationForm: OrganizationForm): Promise<void> {
    await API.PutAsync<OrganizationForm>(
      `${this.baseController}/organizationform`,
      organizationForm
    );
  }

  public async GetOrganizationFormActions(orgFormId: number): Promise<OrganizationFormAction[]> {
    return (
      await API.GetAsync<OrganizationFormAction[]>(
        `${this.baseController}/OrganizationCaseTypeStepForm/list/${orgFormId}`
      )
    ).data ?? [];
  }

  public async AddOrganizationFormAction(
    organizationFormAction: OrganizationFormAction
  ): Promise<OrganizationFormAction> {
    return (
      await API.PostAsync<OrganizationFormAction>(
        `${this.baseController}/OrganizationCaseTypeStepForm`,
        organizationFormAction
      )
    ).data;
  }

  public async RemoveOrganizationFormAction(id: number): Promise<void> {
    return (
      await API.DeleteAsync<void>(`${this.baseController}/OrganizationCaseTypeStepForm/${id}`)
    ).data;
  }

  public async AddLogo(id: number, file: File): Promise<void> {
    const formData = new FormData();

    formData.append('logo', file);

    await API.PostAsync<FormData>(`${this.baseController}/${id}/Logo`, formData);
  }

  public async GetLogo(id: number): Promise<Blob> {
    return (await API.GetFileAsync<Blob>(`${this.baseController}/${id}/Logo`)).data;
  }

  public async AddOrganizationAttachments(
    organizationAttachments: OrganizationAttachment[]
  ): Promise<OrganizationAttachment[]> {
    const formData = new FormData();
    formData.append('organizationId', organizationAttachments[0].organizationId.toString());
    formData.append('attachmentTypeId', organizationAttachments[0].attachmentTypeId.toString());
    organizationAttachments.forEach((item) => {
      formData.append('files', item.file);
    });
    return (
      await API.Post2Async<FormData, OrganizationAttachment[]>(
        `${this.baseController}/attachment`,
        formData
      )
    ).data ?? [];
  }

  public async GetOrganizationAttachments(
    request: OrganizationAttachmentsFiltersDto
  ): Promise<OrganizationAttachmentList> {
    return (
      await API.Post2Async<OrganizationAttachmentsFiltersDto, OrganizationAttachmentList>(
        `${this.baseController}/attachments`,
        request
      )
    ).data;
  }

  public async GetOrganizationAttachment(fileName: string): Promise<Blob> {
    return (await API.GetFileAsync<Blob>(`${this.baseController}/attachment/${fileName}`)).data;
  }

  public async RemoveOrganizationAttachment(fileName: string): Promise<void> {
    await API.DeleteAsync<void>(`${this.baseController}/attachment/${fileName}`);
  }

  public async AddOrganizationJobType(organizationJobType: OrganizationJobType): Promise<void> {
    await API.PostAsync<OrganizationJobType>(
      `${this.baseController}/OrganizationJobType`,
      organizationJobType
    );
  }

  public async RemoveOrganizationJobType(id: number): Promise<void> {
    return (await API.DeleteAsync<void>(`${this.baseController}/OrganizationJobType/${id}`)).data;
  }

  public async GetOrganizationJobTypes(orgId: number): Promise<OrganizationJobType[]> {
    return (
      await API.GetAsync<OrganizationJobType[]>(
        `${this.baseController}/OrganizationJobType/list/${orgId}`
      )
    ).data ?? [];
  }

  public async AddOrganizationMaintenancePackage(
    organizationMaintenancePackage: OrganizationMaintenancePackage
  ): Promise<void> {
    await API.PostAsync<OrganizationMaintenancePackage>(
      `${this.baseController}/OrganizationMaintenancePackage`,
      organizationMaintenancePackage
    );
  }

  public async RemoveOrganizationMaintenancePackage(id: number): Promise<void> {
    return (
      await API.DeleteAsync<void>(`${this.baseController}/OrganizationMaintenancePackage/${id}`)
    ).data;
  }

  public async GetOrganizationMaintenancePackages(
    orgId: number
  ): Promise<OrganizationMaintenancePackage[]> {
    return (
      await API.GetAsync<OrganizationMaintenancePackage[]>(
        `${this.baseController}/OrganizationMaintenancePackage/list/${orgId}`
      )
    ).data ?? [];
  }

  public async AddOrganizationOilViscosity(
    organizationOilViscosity: OrganizationOilViscosity
  ): Promise<void> {
    await API.PostAsync<OrganizationOilViscosity>(
      `${this.baseController}/OrganizationOilViscosity`,
      organizationOilViscosity
    );
  }

  public async UpdateOrganizationOilViscosity(
    organizationOilViscosity: OrganizationOilViscosity
  ): Promise<void> {
    await API.PutAsync<OrganizationOilViscosity>(
      `${this.baseController}/OrganizationOilViscosity`,
      organizationOilViscosity
    );
  }

  public async RemoveOrganizationOilViscosity(id: number): Promise<void> {
    return (await API.DeleteAsync<void>(`${this.baseController}/OrganizationOilViscosity/${id}`))
      .data;
  }

  public async GetOrganizationOilViscosities(orgId: number): Promise<OrganizationOilViscosity[]> {
    return (
      await API.GetAsync<OrganizationOilViscosity[]>(
        `${this.baseController}/OrganizationOilViscosity/list/${orgId}`
      )
    ).data ?? [];
  }

  public async CupiCodeCorespondenceList(): Promise<CupiCodeCorespondence[]> {
    return (
      await API.GetAsync<CupiCodeCorespondence[]>(
        `${this.baseController}/GtCupiCodeCorespondence/listUser`
      )
    ).data ?? [];
  }

  public async AddCupiCodeCorespondence(
    cupiCodeCorespondence: CupiCodeCorespondence
  ): Promise<void> {
    await API.PostAsync<CupiCodeCorespondence>(
      `${this.baseController}/GtCupiCodeCorespondence`,
      cupiCodeCorespondence
    );
  }

  public async UpdateCupiCodeCorespondence(
    cupiCodeCorespondence: CupiCodeCorespondence
  ): Promise<void> {
    await API.PutAsync<CupiCodeCorespondence>(
      `${this.baseController}/GtCupiCodeCorespondence`,
      cupiCodeCorespondence
    );
  }

  public async RemoveCupiCodeCorespondence(id: number): Promise<void> {
    return (await API.DeleteAsync<void>(`${this.baseController}/GtCupiCodeCorespondence/${id}`))
      .data;
  }

  public async AddOrganizationInvoiceRange(
    organizationInvoiceRange: OrganizationInvoiceRange
  ): Promise<void> {
    await API.PostAsync<OrganizationInvoiceRange>(
      `${this.baseController}/OrganizationInvoiceRange`,
      organizationInvoiceRange
    );
  }

  public async UpdateOrganizationInvoiceRange(
    organizationInvoiceRange: OrganizationInvoiceRange
  ): Promise<void> {
    await API.PutAsync<OrganizationInvoiceRange>(
      `${this.baseController}/OrganizationInvoiceRange`,
      organizationInvoiceRange
    );
  }

  public async RemoveOrganizationInvoiceRange(id: number): Promise<void> {
    return (await API.DeleteAsync<void>(`${this.baseController}/OrganizationInvoiceRange/${id}`))
      .data;
  }

  public async GetOrganizationInvoiceRanges(orgId: number): Promise<OrganizationInvoiceRange[]> {
    return (
      await API.GetAsync<OrganizationInvoiceRange[]>(
        `${this.baseController}/OrganizationInvoiceRange/list/${orgId}`
      )
    ).data ?? [];
  }

  public async GetSupplierStockOrganization(types: string): Promise<Organization> {
    return (await API.GetAsync<Organization>(`${this.baseController}/supplierStock/${types}`)).data;
  }

  public async GetOrganizationOilMapping(
    request: OrganizationOilMappingRequest
  ): Promise<OrganizationOilViscosity> {
    return (
      await API.Post2Async<OrganizationOilMappingRequest, OrganizationOilViscosity>(
        `${this.baseController}/oil-mapping`,
        request
      )
    ).data;
  }

  public async AddCountryBuffer(countryBuffer: CountryBuffer): Promise<void> {
    await API.PostAsync<CountryBuffer>(`${this.baseController}/CountryBuffer`, countryBuffer);
  }

  public async UpdateCountryBuffer(countryBuffer: CountryBuffer): Promise<void> {
    await API.PutAsync<CountryBuffer>(`${this.baseController}/CountryBuffer`, countryBuffer);
  }

  public async RemoveCountryBuffer(id: number): Promise<void> {
    return (await API.DeleteAsync<void>(`${this.baseController}/CountryBuffer/${id}`)).data;
  }

  public async GetCountryBuffers(): Promise<CountryBuffer[]> {
    return (await API.GetAsync<CountryBuffer[]>(`${this.baseController}/CountryBuffer/listUser`))
      .data ?? [];
  }

  public async GetSellerDataList(): Promise<SellerData[]> {
    return (await API.GetAsync<SellerData[]>(`${this.baseController}/SellerData/listUser`)).data ?? [];
  }

  public async AddSellerData(sellerData: SellerData): Promise<SellerData> {
    return (await API.PostAsync<SellerData>(`${this.baseController}/SellerData`, sellerData)).data;
  }

  public async RemoveSellerData(id: number): Promise<void> {
    return (await API.DeleteAsync<void>(`${this.baseController}/SellerData/${id}`)).data;
  }

  public async UpdateSellerData(sellerData: SellerData): Promise<void> {
    await API.PutAsync<SellerData>(`${this.baseController}/SellerData`, sellerData);
  }

  public async AddSellerLogo(id: number, file: File): Promise<void> {
    const formData = new FormData();

    formData.append('logo', file);

    await API.PostAsync<FormData>(`${this.baseController}/SellerData/${id}/Logo`, formData);
  }

  public async GetSellerLogo(id: number): Promise<Blob> {
    return (await API.GetFileAsync<Blob>(`${this.baseController}/SellerData/${id}/Logo`)).data;
  }

  public async GetUserCountrySupports(): Promise<CountrySupport[]> {
    return (await API.GetAsync<CountrySupport[]>(`${this.baseController}/CountrySupport/listUser`))
      .data ?? [];
  }

  public async AddCountrySupport(countrySupport: CountrySupport): Promise<CountrySupport> {
    return (
      await API.PostAsync<CountrySupport>(`${this.baseController}/CountrySupport`, countrySupport)
    ).data;
  }

  public async UpdateCountrySupport(countrySupport: CountrySupport): Promise<void> {
    await API.PutAsync<CountrySupport>(`${this.baseController}/CountrySupport`, countrySupport);
  }

  public async RemoveCountrySupport(id: number): Promise<void> {
    return (await API.DeleteAsync<void>(`${this.baseController}/CountrySupport/${id}`)).data;
  }

  public async GetUserPowerBiReports(): Promise<PowerBiReport[]> {
    return (await API.GetAsync<PowerBiReport[]>(`${this.baseController}/PowerBiReport/listUser`))
      .data ?? [];
  }

  public async AddPowerBiReport(powerBiReport: PowerBiReport): Promise<PowerBiReport> {
    return (
      await API.PostAsync<PowerBiReport>(`${this.baseController}/PowerBiReport`, powerBiReport)
    ).data;
  }

  public async UpdatePowerBiReport(powerBiReport: PowerBiReport): Promise<void> {
    await API.PutAsync<PowerBiReport>(`${this.baseController}/PowerBiReport`, powerBiReport);
  }

  public async RemovePowerBiReport(id: number): Promise<void> {
    return (await API.DeleteAsync<void>(`${this.baseController}/PowerBiReport/${id}`)).data;
  }

  public async GetPowerBiReportByCode(code: string): Promise<PowerBiReport> {
    return (await API.GetAsync<PowerBiReport>(`${this.baseController}/powerBi/${code}`)).data;
  }

  public async GetCitiesByCountryCode(countryCode: string): Promise<IReferential[]> {
    return (
      await API.GetAsync<IReferential[]>(
        `${this.baseController}/citiesByCountryCode/${countryCode}`
      )
    ).data ?? [];
  }

  public async GetTermeneInfo(cui: string): Promise<TermeneResponseDto> {
    return (await API.GetAsync<TermeneResponseDto>(`${this.baseController}/termene/${cui}`)).data;
  }

  public async GetUserOilViscosityMakeCorrespondences(): Promise<OilViscosityMakeCorrespondence[]> {
    return (
      await API.GetAsync<OilViscosityMakeCorrespondence[]>(
        `${this.baseController}/OilViscosityMakeCorrespondence/listUser`
      )
    ).data ?? [];
  }

  public async AddOilViscosityMakeCorrespondence(
    oilViscosityMakeCorrespondence: OilViscosityMakeCorrespondence
  ): Promise<OilViscosityMakeCorrespondence> {
    return (
      await API.PostAsync<OilViscosityMakeCorrespondence>(
        `${this.baseController}/OilViscosityMakeCorrespondence`,
        oilViscosityMakeCorrespondence
      )
    ).data;
  }

  public async UpdateOilViscosityMakeCorrespondence(
    oilViscosityMakeCorrespondence: OilViscosityMakeCorrespondence
  ): Promise<void> {
    await API.PutAsync<OilViscosityMakeCorrespondence>(
      `${this.baseController}/OilViscosityMakeCorrespondence`,
      oilViscosityMakeCorrespondence
    );
  }

  public async RemoveOilViscosityMakeCorrespondence(id: number): Promise<void> {
    return (
      await API.DeleteAsync<void>(`${this.baseController}/OilViscosityMakeCorrespondence/${id}`)
    ).data;
  }

  public async GetAdvertisersOrganizationInterfaces(
    orgId: number
  ): Promise<OrganizationInterface[]> {
    return (
      await API.GetAsync<OrganizationInterface[]>(
        `${this.baseController}/advertiser-interfaces/${orgId}`
      )
    ).data ?? [];
  }

  public async GetMvoOrganizations(): Promise<Organization[]> {
    return (await API.GetAsync<Organization[]>(`${this.baseController}/mvo/list`)).data ?? [];
  }

  public async GetDealerStartStocks(include: boolean): Promise<DealerStartStock[]> {
    return (
      await API.GetAsync<DealerStartStock[]>(
        `${this.baseController}/dealer-start-stock-list/${include}`
      )
    ).data ?? [];
  }

  public async AddDealerStartStock(dealerStartStock: DealerStartStock): Promise<DealerStartStock> {
    return (
      await API.PostAsync<DealerStartStock>(
        `${this.baseController}/DealerStartStock`,
        dealerStartStock
      )
    ).data;
  }

  public async UpdateDealerStartStock(dealerStartStock: DealerStartStock): Promise<void> {
    await API.PutAsync<DealerStartStock>(
      `${this.baseController}/DealerStartStock`,
      dealerStartStock
    );
  }

  public async RemoveDealerStartStock(id: number): Promise<void> {
    return (await API.DeleteAsync<void>(`${this.baseController}/DealerStartStock/${id}`)).data;
  }

  public async GetOrganizationsByTypes(
    request: GetOrganizationsByTypesRequestDto
  ): Promise<OrganizationInfoDto[]> {
    return (
      await API.Post2Async<GetOrganizationsByTypesRequestDto, OrganizationInfoDto[]>(
        `${this.baseController}/by-org-types`,
        request
      )
    ).data ?? [];
  }

  public async GetUserMaintenanceWorkflows(): Promise<MaintenanceWorkflow[]> {
    return (
      await API.GetAsync<MaintenanceWorkflow[]>(
        `${this.baseController}/MaintenanceWorkflow/listUser`
      )
    ).data ?? [];
  }

  public async AddMaintenanceWorkflow(
    maintenanceWorkflow: MaintenanceWorkflow
  ): Promise<MaintenanceWorkflow> {
    return (
      await API.PostAsync<MaintenanceWorkflow>(
        `${this.baseController}/MaintenanceWorkflow`,
        maintenanceWorkflow
      )
    ).data;
  }

  public async UpdateMaintenanceWorkflow(maintenanceWorkflow: MaintenanceWorkflow): Promise<void> {
    await API.PutAsync<MaintenanceWorkflow>(
      `${this.baseController}/MaintenanceWorkflow`,
      maintenanceWorkflow
    );
  }

  public async RemoveMaintenanceWorkflow(id: number): Promise<void> {
    return (await API.DeleteAsync<void>(`${this.baseController}/MaintenanceWorkflow/${id}`)).data;
  }

  public async GetMaintenancePackagesByCountry(countryCode: string): Promise<IReferential[]> {
    return (
      await API.GetAsync<IReferential[]>(`${this.baseController}/MaintenancePackage/${countryCode}`)
    ).data ?? [];
  }

  public async GetOrganizationSuppliers(organizationId: number): Promise<OrganizationSupplier[]> {
    return (
      await API.GetAsync<OrganizationSupplier[]>(
        `${this.baseController}/OrganizationSupplier/list/${organizationId}`
      )
    ).data ?? [];
  }

  public async AddOrganizationSupplier(organizationSupplier: OrganizationSupplier): Promise<void> {
    await API.PostAsync<OrganizationSupplier>(
      `${this.baseController}/OrganizationSupplier`,
      organizationSupplier
    );
  }

  public async UpdateOrganizationSupplier(
    organizationSupplier: OrganizationSupplier
  ): Promise<void> {
    await API.PutAsync<OrganizationSupplier>(
      `${this.baseController}/OrganizationSupplier`,
      organizationSupplier
    );
  }

  public async RemoveOrganizationSupplier(id: number): Promise<void> {
    return (
      await API.DeleteAsync<void>(`${this.baseController}/organization-supplier-delete/${id}`)
    ).data;
  }

  public async GetOrganizationSupplierProducerDiscounts(
    organizationSupplierId: number
  ): Promise<OrganizationSupplierProducerDiscount[]> {
    return (
      await API.GetAsync<OrganizationSupplierProducerDiscount[]>(
        `${this.baseController}/OrganizationSupplierProducerDiscount/list/${organizationSupplierId}`
      )
    ).data ?? [];
  }

  public async AddOrganizationSupplierProducerDiscount(
    organizationSupplierProducerDiscount: OrganizationSupplierProducerDiscount
  ): Promise<OrganizationSupplierProducerDiscountResponseDto> {
    return (
      await API.Post2Async<
        OrganizationSupplierProducerDiscount,
        OrganizationSupplierProducerDiscountResponseDto
      >(
        `${this.baseController}/OrganizationSupplierProducerDiscount/add`,
        organizationSupplierProducerDiscount
      )
    ).data;
  }

  public async UpdateOrganizationSupplierProducerDiscount(
    organizationSupplierProducerDiscount: OrganizationSupplierProducerDiscount
  ): Promise<void> {
    await API.PutAsync<OrganizationSupplierProducerDiscount>(
      `${this.baseController}/OrganizationSupplierProducerDiscount`,
      organizationSupplierProducerDiscount
    );
  }

  public async RemoveOrganizationSupplierProducerDiscount(id: number): Promise<void> {
    return (
      await API.DeleteAsync<void>(
        `${this.baseController}/OrganizationSupplierProducerDiscount/${id}`
      )
    ).data;
  }

  public async GetOrganizationSuppliersByOrgId(orgId: number): Promise<OrganizationSupplier[]> {
    return (
      await API.GetAsync<OrganizationSupplier[]>(
        `${this.baseController}/suppliers-by-org-id/${orgId}`
      )
    ).data ?? [];
  }

  public async GetOrganizationProviders(request: GetOrganizationProviderListRequestDto): Promise<OrganizationProvider[]> {
    return (await API.Post2Async<GetOrganizationProviderListRequestDto, OrganizationProvider[]>(`${this.baseController}/providers/list`, request)).data ?? [];
  }

  public async RemoveOrganizationProvider(id: number): Promise<void> {
    await API.DeleteAsync(`${this.baseController}/OrganizationProvider/${id}`);
  }

  public async AddOrganizationProvider(request: AddOrganizationProviderRequestDto): Promise<OrganizationProvider | null> {
    return (await API.Post2Async<AddOrganizationProviderRequestDto, OrganizationProvider>(`${this.baseController}/providers/add`, request)).data;
  }


  public async SaveImportedOrganizations(request: ImportOrganizationsRequestDto): Promise<ImportOrganizationsResponseDto> {
    const formData = new FormData();
    formData.append('content', request.attachments[0].file);

    return (
      await API.Post2Async<FormData, ImportOrganizationsResponseDto>(
        `${this.baseController}/import`,
        formData
      )
    ).data;
  }

  public async GetOrganizationByIds(
    request: OrganizationByIdsRequestDto
  ): Promise<OrganizationInfoDto[]> {
    return (
      await API.Post2Async<OrganizationByIdsRequestDto, OrganizationInfoDto[]>(
        `${this.baseController}/by-ids`,
        request
      )
    ).data ?? [];
  }

  public async GetOrganizations(request: GetOrganizationsRequestDto): Promise<Organization[]> {
    return (
      await API.Post2Async<GetOrganizationsRequestDto, Organization[]>(
        `${this.baseController}/all`,
        request
      )
    ).data ?? [];
  }

  public async GetOrganizationBranding(organizationId: number): Promise<OrganizationBrandingDto> {
    return (
      await API.GetAsync<OrganizationBrandingDto>(
        `${this.baseController}/OrganizationBranding/${organizationId}`
      )
    ).data;
  }

  public async SaveOrganizationBranding(
    request: OrganizationBrandingDto
  ): Promise<SaveOrganizationBrandingResponseDto> {
    return (
      await API.Post2Async<OrganizationBrandingDto, SaveOrganizationBrandingResponseDto>(
        `${this.baseController}/OrganizationBranding`,
        request
      )
    ).data;
  }

  public async GetOrganizationDomains(organizationId: number): Promise<OrganizationDomainDto[]> {
    return (
      await API.GetAsync<OrganizationDomainDto[]>(
        `${this.baseController}/OrganizationDomain/list/${organizationId}`
      )
    ).data;
  }

  public async SaveOrganizationDomain(
    request: OrganizationDomainDto
  ): Promise<SaveOrganizationDomainResponseDto> {
    return (
      await API.Post2Async<OrganizationDomainDto, SaveOrganizationDomainResponseDto>(
        `${this.baseController}/OrganizationDomain`,
        request
      )
    ).data;
  }

  public async DeleteOrganizationDomain(id: number): Promise<void> {
    await API.DeleteAsync<void>(`${this.baseController}/OrganizationDomain/${id}`);
  }

  public async RegenerateOrganizationDomainApiKey(
    request: RegenerateOrganizationDomainApiKeyRequestDto
  ): Promise<OrganizationDomainDto> {
    return (
      await API.Post2Async<RegenerateOrganizationDomainApiKeyRequestDto, OrganizationDomainDto>(
        `${this.baseController}/OrganizationDomain/regenerate-token`,
        request
      )
    ).data;
  }

  public async GetOrganizationBuyoutConfig(
    organizationId: number
  ): Promise<OrganizationBuyoutConfigDto> {
    return (
      await API.GetAsync<OrganizationBuyoutConfigDto>(
        `${this.baseController}/OrganizationBuyoutConfig/${organizationId}`
      )
    ).data;
  }

  public async SaveOrganizationBuyoutConfig(
    request: OrganizationBuyoutConfigDto
  ): Promise<SaveOrganizationBuyoutConfigResponseDto> {
    return (
      await API.Post2Async<OrganizationBuyoutConfigDto, SaveOrganizationBuyoutConfigResponseDto>(
        `${this.baseController}/OrganizationBuyoutConfig`,
        request
      )
    ).data;
  }

  public async GetIntegrationApiLogList(
    filter: IntegrationApiLogFilterRequestDto
  ): Promise<IntegrationApiLogFilterResponseDto> {
    return (
      await API.Post2Async<IntegrationApiLogFilterRequestDto, IntegrationApiLogFilterResponseDto>(
        `${this.baseController}/IntegrationApiLog/filter`,
        filter
      )
    ).data;
  }

  public async GetIntegrationApiLogExport(filter: IntegrationApiLogFilterRequestDto): Promise<Blob> {
    return (
      await API.PostFileAsync<IntegrationApiLogFilterRequestDto, Blob>(
        `${this.baseController}/IntegrationApiLog/export`,
        filter
      )
    ).data;
  }

  public async GetAdminUserOrganizationsByIds(ids: number[]): Promise<Organization[]> {
    return (await API.Post2Async<number[], Organization[]>(`${this.baseController}/admin/user`, ids))
      .data ?? [];
  }

  public async GetAdminOrganizationsByHO(
    hoId: number,
    minLevelId: number | null
  ): Promise<Organization[]> {
    if (minLevelId !== null) {
      return (
        await API.GetAsync<Organization[]>(
          `${this.baseController}/admin/byHO/${hoId}?minlevelId=${minLevelId}`
        )
      ).data ?? [];
    }

    return (await API.GetAsync<Organization[]>(`${this.baseController}/admin/byHO/${hoId}`)).data ?? [];
  }

  public async GetUsersByIds(request: GetUsersByIdsRequestDto): Promise<UserInformationDto[]> {
    if (request.userIds.length === 0) {
      return [];
    }

    return (
      await API.Post2Async<GetUsersByIdsRequestDto, UserInformationDto[]>(
        `${this.baseController}/users-by-ids`,
        request
      )
    ).data ?? [];
  }

  public async AddPartMapping(partMapping: PartMappingDto): Promise<SavePartMappingResponseDto> {
    return (
      await API.Post2Async<PartMappingDto, SavePartMappingResponseDto>(
        `${this.baseController}/PartMapping`,
        partMapping
      )
    ).data;
  }

  public async UpdatePartMapping(partMapping: PartMappingDto): Promise<SavePartMappingResponseDto> {
    return (
      await API.PutAsync<PartMappingDto, AxiosResponse<SavePartMappingResponseDto>>(
        `${this.baseController}/PartMapping`,
        partMapping
      )
    ).data;
  }

  public async GetPartMappingList(
    filter: PartMappingFilterRequestDto
  ): Promise<PartMappingFilterResponseDto> {
    return (
      await API.Post2Async<PartMappingFilterRequestDto, PartMappingFilterResponseDto>(
        `${this.baseController}/PartMapping/filter`,
        filter
      )
    ).data;
  }

  public async GetPartMappingTree(
    filter: PartMappingFilterRequestDto
  ): Promise<PartMappingTreeResponseDto> {
    return (
      await API.Post2Async<PartMappingFilterRequestDto, PartMappingTreeResponseDto>(
        `${this.baseController}/PartMapping/tree`,
        filter
      )
    ).data;
  }

  public async GetPartMappingExport(filter: PartMappingFilterRequestDto): Promise<Blob> {
    return (
      await API.PostFileAsync<PartMappingFilterRequestDto, Blob>(
        `${this.baseController}/PartMapping/export`,
        filter
      )
    ).data;
  }

  public async DeletePartMapping(
    organizationId: number,
    id: number
  ): Promise<DeletePartMappingResponseDto> {
    return (
      await API.DeleteAsync<DeletePartMappingResponseDto>(
        `${this.baseController}/PartMapping/${organizationId}/${id}`
      )
    ).data;
  }

  public async ImportPartMappings(
    request: PartMappingImportRequestDto
  ): Promise<PartMappingImportResponseDto> {
    const formData = new FormData();
    formData.append('content', request.content);
    formData.append('organizationId', request.organizationId.toString());

    return (
      await API.Post2Async<FormData, PartMappingImportResponseDto>(
        `${this.baseController}/PartMapping/import`,
        formData
      )
    ).data;
  }

  public async CheckPartMappingDuplicate(
    request: PartMappingDuplicateRequestDto
  ): Promise<PartMappingDuplicateResponseDto> {
    return (
      await API.Post2Async<PartMappingDuplicateRequestDto, PartMappingDuplicateResponseDto>(
        `${this.baseController}/PartMapping/duplicate`,
        request
      )
    ).data;
  }

  public async SaveOrganizationOwnMakes(
    request: SaveOrganizationOwnMakesRequestDto
  ): Promise<SaveOrganizationOwnMakeResponseDto> {
    return (
      await API.Post2Async<SaveOrganizationOwnMakesRequestDto, SaveOrganizationOwnMakeResponseDto>(
        `${this.baseController}/OrganizationOwnMake`,
        request
      )
    ).data;
  }

  public async RemoveOrganizationOwnMake(id: number): Promise<void> {
    return (await API.DeleteAsync<void>(`${this.baseController}/OrganizationOwnMake/${id}`)).data;
  }

  public async GetOrganizationOwnMakes(orgId: number): Promise<OrganizationOwnMake[]> {
    return (
      await API.GetAsync<OrganizationOwnMake[]>(
        `${this.baseController}/OrganizationOwnMake/list/${orgId}`
      )
    ).data;
  }

  public async CheckOwnBrand(
    request: OwnBrandCheckRequestDto
  ): Promise<OwnBrandCheckResponseDto> {
    return (
      await API.Post2Async<OwnBrandCheckRequestDto, OwnBrandCheckResponseDto>(
        `${this.baseController}/own-brand/check`,
        request
      )
    ).data;
  }
}
